import React = require("react");
import ReactDOM = require("react-dom");

import { SecurityHelper } from "DistributedTask/Scripts/Components/SecurityDialog";
import { IModalDialogOptions, ModalDialogO } from "VSS/Controls/Dialogs";
import * as LWP from "VSS/LWP";
import { LWPComponent } from "VSSPreview/Flux/Components/LWP";
import Constants = require("DistributedTask/Scripts/Constants");
import VssContext = require("VSS/Context");
import Resources = require("DistributedTask/Scripts/Resources/TFS.Resources.DistributedTask");
import Utils_String = require("VSS/Utils/String");

export interface IApprovalsAndChecksDialogOptions extends IModalDialogOptions {
    resourceType: string,
    resourceId: string,
    name: string
}

export interface IApprovalsAndChecksDialogState {
    dataInitialized: boolean;
    permissionsInitialized: boolean;
}

export class ApprovalsAndChecksDialog extends ModalDialogO<IApprovalsAndChecksDialogOptions> {
    public initializeOptions(options?: IApprovalsAndChecksDialogOptions) {
        this._resourceType = options.resourceType;
        this._resourceId = options.resourceId;
        this._resourceName = options.name;

        super.initializeOptions($.extend({
            minWidth: 1200,
            minHeight: 700,
            title: Utils_String.format(Resources.ApprovalsAndChecksDialogTitle, this._resourceName),
            buttons: null
        }, options));
    }

    public initialize() {
        super.initialize();
        ReactDOM.render<any>(<ChecksControl resourceId={this._resourceId} resourceType={this._resourceType} name={this._resourceName} />, this._element[0]) as ChecksControl;
        this.updateOkButton(true);
    }

    public close(): void {
        ReactDOM.unmountComponentAtNode(this._element[0]);
        super.close();
    }

    private _resourceType: string;
    private _resourceId: string;
    private _resourceName: string;
}

class ChecksControl extends React.Component<IApprovalsAndChecksDialogOptions, IApprovalsAndChecksDialogState> {

    constructor(props: IApprovalsAndChecksDialogOptions) {
        super(props);
        this.state = { dataInitialized: false, permissionsInitialized: false };
        if (this.props.resourceType == Constants.LibraryConstants.VariableGroup){
            this._resourceIdString = "variableGroupId"
            this.getManagePermissionsVariableGroup();
        }
        else if (this.props.resourceType == Constants.LibraryConstants.SecureFile){
            this._resourceIdString = "secureFileId"
            this.getManagePermissionsSecureFile();
        }
    }

    public render(): JSX.Element {
        if (this.state.dataInitialized && this.state.permissionsInitialized){
            return (
                <LWPComponent
                    dependencies={["ms.vss-pipelinechecks.web"]}
                    wrappedProps={{
                        resourceId: this.props.resourceId,
                        resourceType: this.props.resourceType,
                        resourceName: this.props.name,
                        hasManagePermission: this._managePermissions,
                        dataProviderRequestParameters: { [this._resourceIdString]: this.props.resourceId },
                        className: "no-padding"
                    }}
                    wrappedType="checks-overview-component"
                />
            );
        }
        return null;
    }

    public componentDidMount() {
        const contributionService = LWP.getLWPService("IVssContributionService");

        contributionService.getDataAsync("ms.vss-pipelinechecks.checks-data-provider", { [this._resourceIdString] : this.props.resourceId }, true).then((data) => {
            if (this._isMounted) {
                this.setState({ dataInitialized: true });
            }
        }, (error) => {
        });
    }

    public componentWillUnmount() {
        this._isMounted = false;
    }

    private getManagePermissionsVariableGroup() {
        var vssContext = VssContext.getDefaultWebContext()
        var hasPermissionPromiseForProject = SecurityHelper.hasVariableGroupPermission(vssContext.project.id, Number(this.props.resourceId), ChecksControl._manageRolesPermission);

        var hasPermissionPromiseForCollection = SecurityHelper.hasVariableGroupCollectionPermission(Number(this.props.resourceId), ChecksControl._manageRolesPermission);

        hasPermissionPromiseForProject.then((hasPermissionForProject: boolean) => {
            if(hasPermissionForProject){
                hasPermissionPromiseForCollection.then((hasPermissionForCollection: boolean) => {
                    if (hasPermissionForCollection){
                        this._managePermissions = true;
                    }
                    this.setState({ permissionsInitialized: true });
                });
            }else{
                this.setState({ permissionsInitialized: true });
            }
        });
    }

    private getManagePermissionsSecureFile() {
        var vssContext = VssContext.getDefaultWebContext()
        var hasPermissionPromiseForProject = SecurityHelper.hasSecureFilePermission(vssContext.project.id,this.props.resourceId,ChecksControl._manageRolesPermission);

        hasPermissionPromiseForProject.then((hasPermissionForProject: boolean) => {
            this._managePermissions = hasPermissionForProject;
            this.setState({ permissionsInitialized: true });
        });
    }

    private _isMounted = true;
    private _resourceIdString = ""
    private _managePermissions = false;
    private static _manageRolesPermission = 2;
}